const httpUrl = 'https://api.any2order.com'
//const httpUrl = 'http://localhost:5566'
const currUrl = 'luckysushi.dk'
const tempId='a'
export default {
    httpUrl,
    currUrl,
    tempId
}